<template>
    <div class="div">
        <button class="button is-small" :class="{'bold' : isFilled}" @click="openModal" style="width: 55px;">
            {{ car.jibaiseki_scan ? 'DONE' : '---' }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Jibaiseki Scan</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <article v-if="error.status" class="message is-danger">
                        <div class="message-body">
                            <strong>{{ error.message }}!</strong>
                        </div>
                    </article>
                    <article v-if="success" class="message is-success">
                        <div class="message-body">
                            <strong>Success!</strong> File was uploaded!
                        </div>
                    </article>
                    <div class="field">
                        <div class="file has-name is-boxed">
                            <label class="file-label">
                                <input class="file-input" ref="file" v-on:change="handleFileUpload()" type="file">
                                <span class="file-cta">
                                  <span class="file-icon">
                                    <i class="fas fa-upload"></i>
                                  </span>
                                  <span class="file-label">
                                    Choose a file…
                                  </span>
                                </span>
                                <span class="file-name">
                                  {{ fileName }}
                                </span>
                            </label>
                        </div>
                    </div>
                    <p v-if="noFiles" class="text-centered">No Files</p>
                    <div v-for="element in uploadedDocument" :class="{'is-focused': isSelected(element)}" class="button select-image">
                        <span>
                            {{ element.split("/").pop() }}
                        </span>
                        <span class="icon is-small" @click="selectFile(element)">
                            <i class="fas fa-check"></i>
                        </span>
                        <span class="icon is-small"  @click="downloadFile(element)">
                            <i class="fas fa-download"></i>
                        </span>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                    <button class="button is-primary"  @click="uploadDocuments">Save</button>
                    <button class="button" @click="showUploadedFiles" :class="{ 'is-loading': isLoading }">Show Uploaded Files</button>
                    <button class="button is-danger" v-if="readyToDelete" @click="deleteSelectedFiles" :class="{ 'is-loading': isLoading }"><i class="fas fa-trash-alt"></i></button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {
            Datetime
        },
        data () {
            return {
                isActive: false,
                success: false,
                documents: '',
                fileName: 'Only PDF file.',
                error: {
                    status: false,
                    message: []
                },
                carData:{
                    id: this.car.id,
                    query: {
                        jibaiseki: this.car.docs_received,
                    }
                },
                uploadedDocument: null,
                selectedFiles: [],
                noFiles: false,
                mediaLoaded:false,
                isLoading: false,
            }
        },
        methods: {
            handleFileUpload(){
                this.documents = this.$refs.file.files[0];
                this.fileName = this.$refs.file.files[0].name;
            },
            uploadDocuments() {
                this.isLoading = true
                this.success = false
                let formData = new FormData();

                formData.append('jibaiseki', this.documents);
                formData.append('car_id',  this.car.id);

                apiCars
                    .carsUploadDocumentsRequest(formData)
                    .then((response) => {
                        this.success = true
                        this.fileName = 'Only PDF file.'
                        this.isActive = false
                        this.car.jibaiseki_scan = 1
                        this.isLoading = false
                    })
                    .catch(error => {
                        console.log(error)
                        this.isLoading = false
                        if ( error.response && error.response.status === 422 ) {
                            this.error.status = true
                            this.error.message = 'The documents must be a file of type: pdf.'
                        }
                    })
            },
            openModal() {
                this.success = false
                this.isActive = !this.isActive
            },
            showUploadedFiles() {
                this.isLoading = true
                apiCars
                    .getCarDocumentsRequest(this.car.id)
                    .then((response) => {
                    console.log(response.data)
                        this.mediaLoaded = true
                        this.uploadedDocument = response.data.jibaiseki_scans
                        this.noFiles = response.data.jibaiseki_scans === null
                        this.isLoading = false
                    })
                    .catch(error => {
                        console.log(error)
                        this.isLoading = false
                    })
            },
            isSelected(file) {
                return this.selectedFiles.includes(file)
            },
            selectFile(file) {
                if (this.selectedFiles.includes(file)) {
                    this.selectedFiles = this.selectedFiles.filter(item => item !== file)

                } else {
                    this.selectedFiles.push(file)
                }
            },
            deleteSelectedFiles() {
                this.error.status = false
                this.isLoading = true
                this.success = false
                let query = {
                    media: this.selectedFiles
                }
                apiCars
                    .deleteCarMediaFilesRequest(query)
                    .then((response) => {
                        this.isLoading = false
                        this.selectedFiles = []
                        this.showUploadedFiles()
                        this.car.jibaiseki_scan = null
                    })
                    .catch(error => {
                        this.selectedFiles = []
                        this.isLoading = false
                        console.log(error)

                    })
            },
            downloadFile(element) {
                const locationHostnameDevelopment =  '127.0.0.1:8000'
                const locationHostnameProduction  =  'unetworld.com'
                const locationHostname = location.host === 'localhost:8080' ? locationHostnameDevelopment : locationHostnameProduction
                const url = location.protocol +'//' + locationHostname + element
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'jibaiseki.xlsx')
                document.body.appendChild(link)
                window.open(link)
            }
        },
        computed: {
            isFilled() {
                if (this.car.jibaiseki_scan){
                    return  true;
                }
            },
            readyToDelete() {
                return this.selectedFiles.length > 0
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Jibaiseki/JibaisekiScanColumn.vue